module.exports = __webpack_public_path__ + "static/media/134.fc5328c5.wav";